/**
 * Product Description Route
 */
import React, { useLayoutEffect } from 'react';
import Layout from '@/components/Layout';
import ProductDescription from '../../../containers/ProductDescription';
import { getCatalogItemById } from '../../../services';
import { checkForWrongDomain } from '@/utils/checkForWrongDomain';
import { set404Response } from '@/utils/404Redirect';
import { useSetSSRStore, useSSRSelector } from '../../../redux';
import { getSSRStoreData } from '../../../utils/ssrPageData';
import { getRequiredCtxProps } from 'src/utils/getRequiredCtxProps';
import { pushFeatureLockCollectiveData } from 'src/utils/hack.featureLocks';
import { handlePDPErrorCaseRedirection } from 'src/utils/productUtils';
import Error404 from 'src/containers/404Page';

const ProductDescPage = (props) => {
  useSetSSRStore(props.ssrStore);
  const storeInfo = useSSRSelector((state) => state.storeReducer.store);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (props?.notFound) {
    return <Error404 />
  }

  return (
    <Layout
      store={storeInfo}
      title={
        props?.advCustomSeoDetails?.title?.value
          ? props?.advCustomSeoDetails?.title?.value
          : `Order ${props?.product?.name} Online From ${storeInfo?.store_info?.name}${
              storeInfo?.address?.visibility === 1 && storeInfo.address?.city
                ? `,${storeInfo.address?.city}`
                : ``
            }`
      }
      OGTitle={props?.advCustomSeoDetails?.og_title?.value || null}
      OGDescription={props?.advCustomSeoDetails?.og_description || null}
      Icon={props?.product?.thumbnail_url}
      metaDescription={
        props?.advCustomSeoDetails?.description
          ? props?.advCustomSeoDetails?.description
          : `Order Online ${props?.product?.name} for Rs.${props?.product?.price}. Shop from ${storeInfo?.store_info?.name},${storeInfo.address?.city} | ${props?.product?.description}`
      }
      isCustomDomain={props.isCustomDomain}
      canonicalTagUrl={props?.product?.link}
      {...props}
    >
      <ProductDescription {...props} />
    </Layout>
  );
};

export async function getServerSideProps(ctx) {
  if (checkForWrongDomain(ctx)) return {};
  const { pid } = ctx.query;
  let propData = {
    product: {},
    catalogCategories: [],
    isCustomDomain: false,
    catalogTags: [],
    collections: [],
    advCustomSeoDetails: {},
  };
  // to check only for number string
  const regExp = /[a-zA-Z]/g;
  if (regExp.test(pid)) {
    return set404Response(ctx);
  }

  const propType = await getSSRStoreData(ctx, {
    additionalDataToFetch: ['collections', 'categories', 'advancedSeo'],
    advancedSeoReqConfigs: {
      type: 'item',
      typeId: pid,
    },
  });

  /**
   * This was a hack to retry fetching the required SSR data if it is not there.
   * discuss with respective devs before making any changes here or reordering this peice of code.
   */
  const { advCustomSeoDetails } = await pushFeatureLockCollectiveData({
    storeInfo: propType?.ssrStore?.storeReducer?.store,
    advancedSeoReqConfigs: {
      type: 'item',
      typeId: pid,
    },
    additionalDataToFetch: ['collections', 'categories', 'advancedSeo'],
    propType,
    ctx,
  });

  const storeId = propType?.ssrStore?.storeReducer?.store?.store_id;

  if (!storeId) {
    return set404Response(ctx);
  }

  const productResponse = await getCatalogItemById(storeId, pid);

  if (productResponse.data && productResponse.data.status) {
    const productItem = JSON.parse(productResponse?.data?.data);
    propData.product = productItem;
  } else {
    return handlePDPErrorCaseRedirection({ ctx, productResponse, propType });
  }

  const extraProps = getRequiredCtxProps(ctx, propType);

  propData = { ...propData, ...propType };

  return { props: { ...propData, ...extraProps, advCustomSeoDetails } };
}

export default ProductDescPage;
